import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import SpecialIntructionsTooltip from 'components/summary/SpecialInstructionsTooltip/component';

export default styled(SpecialIntructionsTooltip)`
  padding: ${gridSizes('S')} ${gridSizes('M')};

  .tipWrapper {
    margin-bottom: ${gridSizes('M')};
    display: flex;

    .iconlessInstruction {
      margin-left: 2.4rem;
      padding-left: ${gridSizes('M')};
    }
  }

  svg {
    fill: #edd324 !important;
    margin-right: ${gridSizes('M')};
  }
`;
